import { Buffer } from "buffer";

global.Buffer = Buffer;
// global.buffer = Buffer;
// global.crypto = crypto;
